import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { initializeGlobalErrorMessages } from './shared/forms/magic/magic-form.messages'
import { LoadingSpinnerComponent } from './shared/loading-spinner/loading-spinner.component'
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoadingSpinnerComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor() {
    initializeGlobalErrorMessages()
  }
}
